import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../components/services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthRoleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.authService.getCurrentUser();

    if (!user) {
      // Send them back where they were headed after login. Routes flagged `signup`
      // (e.g. plan checkout) open the auth page on the provider sign-up form.
      const queryParams: Record<string, string> = { returnUrl: state.url };
      if (route.data['signup']) {
        queryParams['mode'] = 'signup';
        queryParams['role'] = 'provider';
      }
      this.router.navigate(['/auth'], { queryParams });
      return false;
    }

    const requiredRole: string | undefined = route.data['role'];
    // Admin bypasses all role restrictions
    if (requiredRole && user.role !== requiredRole && user.role !== 'admin') {
      this.router.navigate([user.role === 'provider' ? '/provider-dashboard' : '/dashboard']);
      return false;
    }

    return true;
  }
}
